import { Injectable } from '@angular/core';
import { CVApiService } from '../../reusables/services/cv-api.service';
import { IntegrationLog, SelectedFilters } from './integration-mongo-logs.model'; 

@Injectable({
    providedIn: 'root'
})
export class IntegrationMongoLogsService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async getIntegrationLogs(selectedFilters : SelectedFilters) {
        try {
            let startDate = selectedFilters.StartDate.toDateString();
            let endDate = selectedFilters.EndDate.toDateString();
            let result = selectedFilters.Result.join(',');
            let url = `/api/v1/get-integration-logs/${startDate}/${endDate}/${result}`;   
            const response = await this.cvApiService.get<IntegrationLog[]>(url);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for Metric Selector");
            throw err;
        }
    }
}
